import React from "react";

interface Props {
    error: string;
    onRetry: () => void;
}

export const AnswerError = ({ error, onRetry }: Props) => {
    return (
        <div className={"flex flex-col gap-4 rounded-lg bg-white p-4 shadow outline-1"}>
            <div className={"flex grow"}>
                <p>{error}</p>
            </div>

            <button className={"max-w-fit rounded bg-kingspan-gold px-4 py-2 font-bold text-white hover:bg-kingspan-goldDark"} onClick={onRetry}>
                Retry
            </button>
        </div>
    );
};
